export const mockData = [
  {
    "id": 103893,
    "incentiveId": 1198,
    "title": "Bando per l'erogazione di contributi alle PMI giovanili, Anno 2024 - Regione Veneto",
    "slug": "3",
    "description": "Cos'è Il Bando intende promuovere e sostenere le PMI giovanili nei settori dell’artigianato, dell’industria, del commercio e dei servizi quale fattore determinante dello sviluppo economico e sociale del Veneto. Sono ammissibili le spese rientranti nelle seguenti categorie:a) spese relative all'acquisto, o all’acquisizione tramite operazioni di leasing finanziario, di macchinari, impianti produttivi, hardware e attrezzature;b) spese per arredi nuovi di fabbrica;c) spese relative all’acquisto, o all’acquisizione tramite operazioni di leasing finanziario, di negozi mobili;d) spese per l'acquisto di autocarri furgonati ad esclusivo uso aziendale;e) spese per l'acquisto di software, realizzazione di siti web e di e-commerce;f) spese per opere murarie e di impiantistica;g) spese generali. A chi si rivolge I beneficiari sono le PMI giovanili (L. R. 24.12.1999, n. 57) che rientrano in una delle seguenti tipologie:i) imprese individuali i cui titolari siano persone di età compresa tra i diciotto e i trentacinque anni;ii) società e cooperative i cui soci siano per almeno il sessanta per cento persone di età compresa tra i diciotto e i trentacinque anni ovvero il cui capitale sociale sia detenuto per almeno i due terzi da persone di età compresa tra i diciotto e i trentacinque anni. Tali requisiti devono sussistere alla data del 2 febbraio 2024. Le imprese richiedenti devono essere iscritte alla CCIAA alla data del 2 febbraio 2024, anche se inattive. Cosa prevede Si prevede un contributo a fondo perduto, pari al 30% della spesa rendicontata ammissibile per la realizzazione del progetto ed è concesso:- nel limite massimo di euro 51.000,00 su una spesa rendicontata ammissibile pari o superiore a euro 170.000,00;- nel limite minimo di euro 6.000,00 su una spesa rendicontata ammissibile pari a euro 20.000,00. La graduatoria è formata mediante l’attribuzione di un punteggio basato sui criteri di priorità richiesti dall’impresa.",
    "startDate": "2024-03-05T00:00:00.000Z",
    "endDate": "2024-03-19T00:00:00.000Z",
    "status": 0,
    "obiettivoFinalita": "Imprenditoria giovanile",
    "noteAperturaChiusura": null,
    "dimensioni": "Media Impresa,Microimpresa,Piccola Impresa",
    "tipologiaSoggetto": "Impresa - prevalenza giovanile",
    "formaAgevolazione": "Contributo/Fondo perduto",
    "costiAmmessi": "Impianti/Macchinari/Attrezzature,Spese generali/altri oneri",
    "spesaAmmessaMin": "20000.00",
    "spesaAmmessaMax": "170000.00",
    "agevolazioneConcedibileMin": "6000.00",
    "agevolazioneConcedibileMax": "51000.00",
    "settoreAttivita": "Altri servizi,Artigianato,Autoveicoli e altri mezzi di trasporto,Chimica e Farmaceutica,Commercio,Edilizia,Elettronica,Fornitura Energia, Acqua e gestione Rifiuti,ICT,Meccanica,Metallurgia,Mobili, Legno e Carta,Moda e Tessile,Ristorazione,Salute,Servizi di trasporto",
    "codiciAteco": "05.00; 05.10; 05.20; 06.00; 06.10; 06.20; 07.00; 07.10; 07.20; 07.21; 07.29; 08.00; 08.10; 08.11; 08.12; 08.90; 08.91; 08.92; 08.93; 08.99; 09.00; 09.10; 09.90; 10.00; 10.10; 10.11; 10.12; 10.13; 10.20; 10.30; 10.31; 10.32; 10.39; 10.40; 10.41; 10.42; 10.50; 10.51; 10.52; 10.60; 10.61; 10.62; 10.70; 10.71; 10.72; 10.73; 10.80; 10.81; 10.82; 10.83; 10.84; 10.85; 10.86; 10.89; 10.90; 10.91; 10.92; 11.00; 11.01; 11.02; 11.03; 11.04; 11.05; 11.06; 11.07; 12.00; 13.00; 13.10; 13.20; 13.30; 13.90; 13.91; 13.92; 13.93; 13.94; 13.95; 13.96; 13.99; 14.00; 14.10; 14.11; 14.12; 14.13; 14.14; 14.19; 14.20; 14.30; 14.31; 14.39; 15.00; 15.10; 15.11; 15.12; 15.20; 16.00; 16.10; 16.20; 16.21; 16.22; 16.23; 16.24; 16.29; 17.00; 17.10; 17.11; 17.12; 17.20; 17.21; 17.22; 17.23; 17.24; 17.29; 18.00; 18.10; 18.11; 18.12; 18.13; 18.14; 18.20; 19.00; 19.10; 19.20; 20.00; 20.10; 20.11; 20.12; 20.13; 20.14; 20.15; 20.16; 20.17; 20.20; 20.30; 20.40; 20.41; 20.42; 20.50; 20.51; 20.52; 20.53; 20.59; 20.60; 21.00; 21.10; 21.20; 22.00; 22.10; 22.11; 22.19; 22.20; 22.21; 22.22; 22.23; 22.29; 23.00; 23.10; 23.11; 23.12; 23.13; 23.14; 23.19; 23.20; 23.30; 23.31; 23.32; 23.40; 23.41; 23.42; 23.43; 23.44; 23.49; 23.50; 23.51; 23.52; 23.60; 23.61; 23.62; 23.63; 23.64; 23.65; 23.69; 23.70; 23.90; 23.91; 23.99; 24.00; 24.10; 24.20; 24.30; 24.31; 24.32; 24.33; 24.34; 24.40; 24.41; 24.42; 24.43; 24.44; 24.45; 24.46; 24.50; 24.51; 24.52; 24.53; 24.54; 25.00; 25.10; 25.11; 25.12; 25.20; 25.21; 25.29; 25.30; 25.40; 25.50; 25.60; 25.61; 25.62; 25.70; 25.71; 25.72; 25.73; 25.90; 25.91; 25.92; 25.93; 25.94; 25.99; 26.00; 26.10; 26.11; 26.12; 26.20; 26.30; 26.40; 26.50; 26.51; 26.52; 26.60; 26.70; 26.80; 27.00; 27.10; 27.11; 27.12; 27.20; 27.30; 27.31; 27.32; 27.33; 27.40; 27.50; 27.51; 27.52; 27.90; 28.00; 28.10; 28.11; 28.12; 28.13; 28.14; 28.15; 28.20; 28.21; 28.22; 28.23; 28.24; 28.25; 28.29; 28.30; 28.40; 28.41; 28.49; 28.90; 28.91; 28.92; 28.93; 28.94; 28.95; 28.96; 28.99; 29.00; 29.10; 29.20; 29.30; 29.31; 29.32; 30.00; 30.10; 30.11; 30.12; 30.20; 30.30; 30.40; 30.90; 30.91; 30.92; 30.99; 31.00; 31.01; 31.02; 31.03; 31.09; 32.00; 32.10; 32.11; 32.12; 32.13; 32.20; 32.30; 32.40; 32.50; 32.90; 32.91; 32.99; 33.00; 33.10; 33.11; 33.12; 33.13; 33.14; 33.15; 33.16; 33.17; 33.19; 33.20; 36.00; 37.00; 38.00; 38.10; 38.11; 38.12; 38.20; 38.21; 38.22; 38.30; 38.31; 38.32; 39.00; 41.00; 41.10; 41.20; 42.00; 42.10; 42.11; 42.12; 42.13; 42.20; 42.21; 42.22; 42.90; 42.91; 42.99; 43.00; 43.10; 43.11; 43.12; 43.13; 43.20; 43.21; 43.22; 43.29; 43.30; 43.31; 43.32; 43.33; 43.34; 43.39; 43.90; 43.91; 43.99; 45.00; 45.10; 45.11; 45.19; 45.20; 45.30; 45.31; 45.32; 45.40; 46.00; 46.10; 46.11; 46.12; 46.13; 46.14; 46.15; 46.16; 46.17; 46.18; 46.19; 46.20; 46.21; 46.22; 46.23; 46.24; 46.30; 46.31; 46.32; 46.33; 46.34; 46.35; 46.36; 46.37; 46.38; 46.39; 46.40; 46.41; 46.42; 46.43; 46.44; 46.45; 46.46; 46.47; 46.48; 46.49; 46.50; 46.51; 46.52; 46.60; 46.61; 46.62; 46.63; 46.64; 46.65; 46.66; 46.69; 46.70; 46.71; 46.72; 46.73; 46.74; 46.75; 46.76; 46.77; 46.90; 47.00; 47.10; 47.11; 47.19; 47.20; 47.21; 47.22; 47.23; 47.24; 47.25; 47.26; 47.29; 47.30; 47.40; 47.41; 47.42; 47.43; 47.50; 47.51; 47.52; 47.53; 47.54; 47.59; 47.60; 47.61; 47.62; 47.63; 47.64; 47.65; 47.70; 47.71; 47.72; 47.73; 47.74; 47.75; 47.76; 47.77; 47.78; 47.79; 47.80; 47.81; 47.82; 47.89; 47.90; 47.91; 47.99; 49.00; 49.10; 49.20; 49.30; 49.31; 49.32; 49.39; 49.40; 49.41; 49.42; 49.50; 50.00; 50.10; 50.20; 50.30; 50.40; 51.00; 51.10; 51.20; 51.21; 51.22; 52.00; 52.10; 52.20; 52.21; 52.22; 52.23; 52.24; 52.29; 53.00; 53.10; 53.20; 56.00; 56.10; 56.20; 56.21; 56.29; 56.30; 58.00; 58.10; 58.11; 58.12; 58.13; 58.14; 58.19; 58.20; 58.21; 58.29; 59.00; 59.10; 59.11; 59.12; 59.13; 59.14; 59.20; 60.00; 60.10; 60.20; 61.00; 61.10; 61.20; 61.30; 61.90; 62.00; 62.01; 62.02; 62.03; 62.09; 63.00; 63.10; 63.11; 63.12; 63.90; 63.91; 63.99; 69.00; 69.10; 69.20; 70.00; 70.10; 70.20; 70.21; 70.22; 71.00; 71.10; 71.11; 71.12; 71.20; 72.00; 72.10; 72.11; 72.19; 72.20; 73.00; 73.10; 73.11; 73.12; 73.20; 74.00; 74.10; 74.20; 74.30; 74.90; 75.00; 77.00; 77.10; 77.11; 77.12; 77.20; 77.21; 77.22; 77.29; 77.30; 77.31; 77.32; 77.33; 77.34; 77.35; 77.39; 77.40; 78.00; 78.10; 78.20; 78.30; 79.00; 79.10; 79.11; 79.12; 79.90; 80.00; 80.10; 80.20; 80.30; 81.00; 81.10; 81.20; 81.21; 81.22; 81.29; 81.30; 82.00; 82.10; 82.11; 82.19; 82.20; 82.30; 82.90; 82.91; 82.92; 82.99; 86.00; 86.10; 86.20; 86.21; 86.22; 86.23; 86.90; 87.00; 87.10; 87.20; 87.30; 87.90; 88.00; 88.10; 88.90; 88.91; 88.99; 90.00; 90.01; 90.02; 90.03; 90.04; 91.00; 91.01; 91.02; 91.03; 91.04; 92.00; 93.00; 93.10; 93.11; 93.12; 93.13; 93.19; 93.20; 93.21; 93.29; 94.00; 94.10; 94.11; 94.12; 94.20; 94.90; 94.91; 94.92; 94.99; 95.00; 95.10; 95.11; 95.12; 95.20; 95.21; 95.22; 95.23; 95.24; 95.25; 95.29; 96.00; 96.01; 96.02; 96.03; 96.04; 96.09;",
    "regioni": "Veneto",
    "comuni": "Abano Terme; Adria; Affi; Agna; Agordo; Agugliaro; Alano di Piave; Albaredo d&apos;Adige; Albettone; Albignasego; Alleghe; Alonte; Alpago; Altavilla Vicentina; Altissimo; Altivole; Angiari; Anguillara Veneta; Annone Veneto; Arcade; Arcole; Arcugnano; Ariano nel Polesine; Arquà Petrarca; Arquà Polesine; Arre; Arsiero; Arsiè; Arzergrande; Arzignano; Asiago; Asigliano Veneto; Asolo; Auronzo di Cadore; Badia Calavena; Badia Polesine; Bagnoli di Sopra; Bagnolo di Po; Baone; Barbarano Mossano; Barbarano Vicentino; Barbona; Bardolino; Bassano del Grappa; Battaglia Terme; Belfiore; Belluno; Bergantino; Bevilacqua; Boara Pisani; Bolzano Vicentino; Bonavigo; Borca di Cadore; Borgo Valbelluna; Borgo Veneto; Borgoricco; Borso del Grappa; Bosaro; Boschi Sant&apos;Anna; Bosco Chiesanuova; Bovolenta; Bovolone; Breda di Piave; Breganze; Brendola; Brentino Belluno; Brenzone sul Garda; Bressanvido; Brogliano; Brugine; Bussolengo; Buttapietra; Cadoneghe; Caerano di San Marco; Calalzo di Cadore; Caldiero; Caldogno; Calto; Caltrano; Calvene; Camisano Vicentino; Campagna Lupia; Campiglia dei Berici; Campo San Martino; Campodarsego; Campodoro; Campolongo Maggiore; Campolongo sul Brenta; Camponogara; Camposampiero; Canale d&apos;Agordo; Canaro; Canda; Candiana; Caorle; Cappella Maggiore; Caprino Veronese; Carbonera; Carceri; Carmignano di Brenta; Carrè; Cartigliano; Cartura; Casale di Scodosia; Casale sul Sile; Casaleone; Casalserugo; Casier; Cassola; Castagnaro; Castegnero; Castel d&apos;Azzano; Castelbaldo; Castelcucco; Castelfranco Veneto; Castelgomberto; Castelguglielmo; Castello di Godego; Castelmassa; Castelnovo Bariano; Castelnuovo del Garda; Cavaion Veronese; Cavallino-Treporti; Cavarzere; Cavaso del Tomba; Cazzano di Tramigna; Ceggia; Cencenighe Agordino; Ceneselli; Cerea; Ceregnano; Cerro Veronese; Cervarese Santa Croce; Cesiomaggiore; Cessalto; Chiampo; Chiarano; Chies d&apos;Alpago; Chioggia; Chiuppano; Cibiana di Cadore; Cimadolmo; Cinto Caomaggiore; Cinto Euganeo; Cismon del Grappa; Cison di Valmarino; Cittadella; Codevigo; Codognè; Cogollo del Cengio; Colceresa; Colle Santa Lucia; Colle Umberto; Cologna Veneta; Colognola ai Colli; Comelico Superiore; Cona; Concamarise; Conco; Concordia Sagittaria; Conegliano; Conselve; Corbola; Cordignano; Cornedo Vicentino; Cornuda; Correzzola; Cortina d&apos;Ampezzo; Costa di Rovigo; Costabissara; Costermano sul Garda; Creazzo; Crespadoro; Crespano del Grappa; Crespino; Crocetta del Montello; Curtarolo; Danta di Cadore; Dolcè; Dolo; Domegge di Cadore; Due Carrare; Dueville; Enego; Eraclea; Erbezzo; Erbè; Este; Falcade; Fara Vicentino; Farra d&apos;Alpago; Farra di Soligo; Feltre; Ferrara di Monte Baldo; Ficarolo; Fiesso Umbertiano; Fiesso d&apos;Artico; Follina; Fontanelle; Fontaniva; Fonte; Fonzaso; Forno di Zoldo; Fossalta di Piave; Fossalta di Portogruaro; Fossò; Foza; Frassinelle Polesine; Fratta Polesine; Fregona; Fumane; Gaiarine; Gaiba; Galliera Veneta; Gallio; Galzignano Terme; Gambellara; Gambugliano; Garda; Gavello; Gazzo; Gazzo Veronese; Giacciano con Baruchella; Giavera del Montello; Godega di Sant&apos;Urbano; Gorgo al Monticano; Gosaldo; Grancona; Grantorto; Granze; Grezzana; Grisignano di Zocco; Gruaro; Grumolo delle Abbadesse; Guarda Veneta; Illasi; Isola Rizza; Isola Vicentina; Isola della Scala; Istrana; Jesolo; La Valle Agordina; Laghi; Lamon; Lastebasse; Lavagno; Lazise; Legnago; Legnaro; Lendinara; Lentiai; Limana; Limena; Livinallongo del Col di Lana; Longare; Longarone; Lonigo; Loreggia; Lorenzago di Cadore; Loreo; Loria; Lozzo Atestino; Lozzo di Cadore; Lugo di Vicenza; Lusia; Lusiana; Lusiana Conco; Malcesine; Malo; Mansuè; Marano Vicentino; Marano di Valpolicella; Marcon; Mareno di Piave; Marostica; Martellago; Maser; Maserada sul Piave; Maserà di Padova; Masi; Mason Vicentino; Massanzago; Meduna di Livenza; Megliadino San Fidenzio; Megliadino San Vitale; Mel; Melara; Meolo; Merlara; Mestrino; Mezzane di Sotto; Miane; Minerbe; Mira; Mirano; Mogliano Veneto; Molvena; Monastier di Treviso; Monfumo; Monselice; Montagnana; Monte di Malo; Montebello Vicentino; Montebelluna; Montecchia di Crosara; Montecchio Maggiore; Montecchio Precalcino; Monteforte d&apos;Alpone; Montegalda; Montegaldella; Montegrotto Terme; Monteviale; Monticello Conte Otto; Montorso Vicentino; Morgano; Moriago della Battaglia; Mossano; Motta di Livenza; Mozzecane; Musile di Piave; Mussolente; Nanto; Negrar di Valpolicella; Nervesa della Battaglia; Noale; Nogara; Nogarole Rocca; Nogarole Vicentino; Nove; Noventa Padovana; Noventa Vicentina; Noventa di Piave; Occhiobello; Oderzo; Oppeano; Orgiano; Ormelle; Orsago; Ospedaletto Euganeo; Ospitale di Cadore; Paderno del Grappa; Padova; Paese; Palù; Papozze; Pastrengo; Pedavena; Pedemonte; Pederobba; Perarolo di Cadore; Pernumia; Pescantina; Peschiera del Garda; Pettorazza Grimani; Piacenza d&apos;Adige; Pianezze; Pianiga; Piazzola sul Brenta; Pieve d&apos;Alpago; Pieve del Grappa; Pieve di Cadore; Pieve di Soligo; Pincara; Piombino Dese; Piove di Sacco; Piovene Rocchette; Pojana Maggiore; Polesella; Polverara; Ponso; Ponte San Nicolò; Ponte di Piave; Ponte nelle Alpi; Pontecchio Polesine; Pontelongo; Ponzano Veneto; Porto Tolle; Porto Viro; Portobuffolè; Portogruaro; Posina; Possagno; Pove del Grappa; Povegliano; Povegliano Veronese; Pozzoleone; Pozzonovo; Pramaggiore; Preganziol; Pressana; Puos d&apos;Alpago; Quarto d&apos;Altino; Quero Vas; Quinto Vicentino; Quinto di Treviso; Recoaro Terme; Refrontolo; Resana; Revine Lago; Riese Pio X; Rivamonte Agordino; Rivoli Veronese; Roana; Rocca Pietore; Romano d&apos;Ezzelino; Roncade; Ronco all&apos;Adige; Roncà; Rosolina; Rossano Veneto; Rosà; Rotzo; Roverchiara; Roveredo di Guà; Roverè Veronese; Rovigo; Rovolon; Rubano; Saccolongo; Salara; Salcedo; Saletto; Salgareda; Salizzole; Salzano; San Bellino; San Biagio di Callalta; San Bonifacio; San Donà di Piave; San Fior; San Germano dei Berici; San Giorgio delle Pertiche; San Giorgio in Bosco; San Giovanni Ilarione; San Giovanni Lupatoto; San Gregorio nelle Alpi; San Martino Buon Albergo; San Martino di Lupari; San Martino di Venezze; San Mauro di Saline; San Michele al Tagliamento; San Nazario; San Nicolò di Comelico; San Pietro Mussolino; San Pietro Viminario; San Pietro di Cadore; San Pietro di Feletto; San Pietro di Morubio; San Pietro in Cariano; San Pietro in Gu; San Polo di Piave; San Stino di Livenza; San Tomaso Agordino; San Vendemiano; San Vito di Cadore; San Vito di Leguzzano; San Zeno di Montagna; San Zenone degli Ezzelini; Sandrigo; Sanguinetto; Sant&apos;Ambrogio di Valpolicella; Sant&apos;Angelo di Piove di Sacco; Sant&apos;Anna d&apos;Alfaedo; Sant&apos;Elena; Sant&apos;Urbano; Santa Giustina; Santa Giustina in Colle; Santa Lucia di Piave; Santa Margherita d&apos;Adige; Santa Maria di Sala; Santo Stefano di Cadore; Santorso; Saonara; Sappada; Sarcedo; Sarego; Sarmede; Schiavon; Schio; Scorzè; Sedico; Segusino; Selva di Cadore; Selva di Progno; Selvazzano Dentro; Seren del Grappa; Sernaglia della Battaglia; Silea; Soave; Solagna; Solesino; Sommacampagna; Sona; Sorgà; Sospirolo; Sossano; Soverzene; Sovizzo; Sovramonte; Spinea; Spresiano; Stanghella; Stienta; Stra; Susegana; Taglio di Po; Taibon Agordino; Tambre; Tarzo; Teglio Veneto; Teolo; Terrassa Padovana; Terrazzo; Tezze sul Brenta; Thiene; Tombolo; Tonezza del Cimone; Torre di Mosto; Torrebelvicino; Torreglia; Torri del Benaco; Torri di Quartesolo; Trebaseleghe; Trecenta; Tregnago; Trevenzuolo; Trevignano; Treviso; Tribano; Trichiana; Trissino; Urbana; Val Liona; Val di Zoldo; Valbrenta; Valdagno; Valdastico; Valdobbiadene; Valeggio sul Mincio; Vallada Agordina; Valle di Cadore; Valli del Pasubio; Valstagna; Vazzola; Vedelago; Veggiano; Velo Veronese; Velo d&apos;Astico; Venezia; Verona; Veronella; Vescovana; Vestenanova; Vicenza; Vidor; Vigasio; Vighizzolo d&apos;Este; Vigo di Cadore; Vigodarzere; Vigonovo; Vigonza; Villa Bartolomea; Villa Estense; Villa del Conte; Villadose; Villafranca Padovana; Villafranca di Verona; Villaga; Villamarzana; Villanova Marchesana; Villanova del Ghebbo; Villanova di Camposampiero; Villaverla; Villorba; Vittorio Veneto; Vo&apos;; Vodo Cadore; Volpago del Montello; Voltago Agordino; Zanè; Zenson di Piave; Zermeghedo; Zero Branco; Zevio; Zimella; Zoldo Alto; Zoppè di Cadore; Zovencedo; Zugliano",
    "ambitoTerritoriale": null,
    "soggettoConcedente": "Regione Veneto - Direzione Industria Artigianato Commercio e Servizi",
    "baseNormativaPrimaria": "INTERVENTI REGIONALI PER LO SVILUPPO DELL'IMPRENDITORIA GIOVANILE VENETA",
    "baseNormativaSecondaria": null,
    "provvedimentoAttuativo": "INTERVENTI REGIONALI PER LO SVILUPPO DELL'IMPRENDITORIA GIOVANILE VENETA",
    "gazzettaUfficiale": "21 del 13/02/2024",
    "stanziamentoIncentivo": "2000000.00",
    "linkIstituzionale": "https://bandi.regione.veneto.it/Public/Dettaglio?idAtto=9998",
    "altreCaratteristiche": null,
    "criteria": "[\"startup\",\"sedi\"]",
    "dataUltimoAggiornamento": "2024-03-01T10:18:03.000Z",
    "websiteId": null,
    "isNew": true,
    "desc1": "Il Bando intende promuovere e sostenere le PMI giovanili nei settori dell’artigianato, dell’industria, del commercio e dei servizi quale fattore determinante dello sviluppo economico e sociale del Veneto. Sono ammissibili le spese rientranti nelle seguenti categorie:a) spese relative all'acquisto, o all’acquisizione tramite operazioni di leasing finanziario, di macchinari, impianti produttivi, hardware e attrezzature;b) spese per arredi nuovi di fabbrica;c) spese relative all’acquisto, o all’acquisizione tramite operazioni di leasing finanziario, di negozi mobili;d) spese per l'acquisto di autocarri furgonati ad esclusivo uso aziendale;e) spese per l'acquisto di software, realizzazione di siti web e di e-commerce;f) spese per opere murarie e di impiantistica;g) spese generali.",
    "desc2": "I beneficiari sono le PMI giovanili (L. R. 24.12.1999, n. 57) che rientrano in una delle seguenti tipologie:i) imprese individuali i cui titolari siano persone di età compresa tra i diciotto e i trentacinque anni;ii) società e cooperative i cui soci siano per almeno il sessanta per cento persone di età compresa tra i diciotto e i trentacinque anni ovvero il cui capitale sociale sia detenuto per almeno i due terzi da persone di età compresa tra i diciotto e i trentacinque anni. Tali requisiti devono sussistere alla data del 2 febbraio 2024. Le imprese richiedenti devono essere iscritte alla CCIAA alla data del 2 febbraio 2024, anche se inattive.",
    "desc3": "Si prevede un contributo a fondo perduto, pari al 30% della spesa rendicontata ammissibile per la realizzazione del progetto ed è concesso:- nel limite massimo di euro 51.000,00 su una spesa rendicontata ammissibile pari o superiore a euro 170.000,00;- nel limite minimo di euro 6.000,00 su una spesa rendicontata ammissibile pari a euro 20.000,00. La graduatoria è formata mediante l’attribuzione di un punteggio basato sui criteri di priorità richiesti dall’impresa.",
    "type": 3,
    "source": "IMPORT_CSV",
    "createdAt": "2026-02-02T07:00:58.000Z",
    "updatedAt": "2026-02-02T07:00:58.000Z",
    "labels": [
      "Imprenditoria giovanile",
      "Impresa - prevalenza giovanile",
      "Contributo/Fondo perduto",
      "Altri servizi",
      "Artigianato",
      "Autoveicoli e altri mezzi di trasporto",
      "Chimica e Farmaceutica",
      "Commercio",
      "Edilizia",
      "Elettronica",
      "Fornitura Energia",
      " Acqua e gestione Rifiuti",
      "ICT",
      "Meccanica",
      "Metallurgia",
      "Mobili",
      " Legno e Carta",
      "Moda e Tessile",
      "Ristorazione",
      "Salute",
      "Servizi di trasporto",
      "Veneto"
    ],
    "statusDesc": "Chiuso",
    "statusId": 0
  },
  {
    bando: 'Nome bando',
    _id: "103894",
    birthDate: "12/12/2001",
    time: "19:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giallo",
    lastName: "Rossi",
    fisrtName: "Luca",
    cell: "345 6789012",
    slug: "Red",
    id: "39eh3983i",
    description: "Descrizione per Luca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103895",
    birthDate: "12/12/2001",
    time: "22:12",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Verde",
    lastName: "Verdi",
    fisrtName: "Anna",
    cell: "333 1234567",
    slug: "Green",
    id: "19fj1030j",
    description: "Ciao da Mario",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103896",
    birthDate: "12/12/2001",
    time: "11:09",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Blu",
    lastName: "Bianchi",
    fisrtName: "Marco",
    cell: "389 4567890",
    slug: "Blue",
    id: "29dj2031k",
    description: "Descrizione di Marco",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103897",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Viola",
    lastName: "Neri",
    fisrtName: "Giulia",
    cell: "320 6547890",
    slug: "Purple",
    id: "38ej3941l",
    description: "Saluti da Giulia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103898",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Arancio",
    lastName: "Moretti",
    fisrtName: "Paolo",
    cell: "391 2345678",
    slug: "Orange",
    id: "48fj4851m",
    description: "Messaggio da Paolo",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103899",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Rosa",
    lastName: "Ferrari",
    fisrtName: "Sara",
    cell: "347 9876543",
    slug: "Pink",
    id: "59gj5962n",
    description: "Ciao da Sara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103900",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Indaco",
    lastName: "Pellegrini",
    fisrtName: "Davide",
    cell: "349 8765432",
    slug: "Indigo",
    id: "69hj6073o",
    description: "Descrizione di Davide",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103901",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giorgio",
    lastName: "Leoni",
    fisrtName: "Claudio",
    cell: "360 7654321",
    slug: "Lion",
    id: "79ij7184p",
    description: "Claudio saluta tutti",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103902",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Francesco",
    lastName: "Esposito",
    fisrtName: "Mario",
    cell: "371 6543210",
    slug: "Frank",
    id: "89kj8295q",
    description: "Messaggio di Mario",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103903",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Lorenzo",
    lastName: "Ricci",
    fisrtName: "Giovanni",
    cell: "388 5432109",
    slug: "Larry",
    id: "99lj9306r",
    description: "Giovanni dice ciao",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103904",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Federico",
    lastName: "Romano",
    fisrtName: "Stefano",
    cell: "321 4321098",
    slug: "Fred",
    id: "10mj0417s",
    description: "Descrizione di Stefano",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103905",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Matteo",
    lastName: "Conti",
    fisrtName: "Alessandro",
    cell: "322 3210987",
    slug: "Matt",
    id: "11nj1528t",
    description: "Saluti da Alessandro",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103906",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Simone",
    lastName: "De Luca",
    fisrtName: "Francesca",
    cell: "324 2109876",
    slug: "Simon",
    id: "12oj2639u",
    description: "Descrizione per Francesca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103907",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Andrea",
    lastName: "Mariani",
    fisrtName: "Elena",
    cell: "325 1098765",
    slug: "Andy",
    id: "13pj3740v",
    description: "Elena manda saluti",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103908",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Alessio",
    lastName: "Fontana",
    fisrtName: "Giorgia",
    cell: "326 9876543",
    slug: "Alex",
    id: "14qj4851w",
    description: "Messaggio da Giorgia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103909",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Daniele",
    lastName: "Martini",
    fisrtName: "Chiara",
    cell: "327 8765432",
    slug: "Dan",
    id: "15rj5962x",
    description: "Descrizione di Chiara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103910",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Filippo",
    lastName: "Fabbri",
    fisrtName: "Federica",
    cell: "328 7654321",
    slug: "Phil",
    id: "16sj6073y",
    description: "Federica dice ciao",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103911",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Tommaso",
    lastName: "Barbieri",
    fisrtName: "Valeria",
    cell: "329 6543210",
    slug: "Tom",
    id: "17tj7184z",
    description: "Messaggio da Valeria",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103912",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Leonardo",
    lastName: "Galli",
    fisrtName: "Giada",
    cell: "330 5432109",
    slug: "Leo",
    id: "18uj8295a",
    description: "Descrizione di Giada",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103913",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Emanuele",
    lastName: "Vitali",
    fisrtName: "Lorenza",
    cell: "331 4321098",
    slug: "Manu",
    id: "19vj9306b",
    description: "Saluti da Lorenza",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103914",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Gabriele",
    lastName: "Orlandi",
    fisrtName: "Barbara",
    cell: "332 3210987",
    slug: "Gab",
    id: "20wj0417c",
    description: "Messaggio di Barbara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103915",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Pietro",
    lastName: "Ruggieri",
    fisrtName: "Alice",
    cell: "333 2109876",
    slug: "Pete",
    id: "21xj1528d",
    description: "Alice manda un saluto",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103916",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Nicolo",
    lastName: "Greco",
    fisrtName: "Bianca",
    cell: "334 1098765",
    slug: "Nick",
    id: "22yj2639e",
    description: "Descrizione per Bianca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103917",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Samuele",
    lastName: "Sanna",
    fisrtName: "Laura",
    cell: "335 9876543",
    slug: "Sam",
    id: "23zj3740f",
    description: "Saluti da Laura",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103918",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giuseppe",
    lastName: "Cattaneo",
    fisrtName: "Camilla",
    cell: "336 8765432",
    slug: "Joe",
    id: "24ak4851g",
    description: "Descrizione di Camilla",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103919",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Luca",
    lastName: "Bruno",
    fisrtName: "Carla",
    cell: "337 7654321",
    slug: "Luke",
    id: "25bk5962h",
    description: "Messaggio da Carla",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103920",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Vincenzo",
    lastName: "Parisi",
    fisrtName: "Martina",
    cell: "338 6543210",
    slug: "Vince",
    id: "26ck6073i",
    description: "Saluti da Martina",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103921",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Alberto",
    lastName: "Benedetti",
    fisrtName: "Elisa",
    cell: "339 5432109",
    slug: "Al",
    id: "27dk7184j",
    description: "Messaggio di Elisa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103922",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Edoardo",
    lastName: "Ferri",
    fisrtName: "Cristina",
    cell: "340 4321098",
    slug: "Edo",
    id: "28ek8295k",
    description: "Saluti da Cristina",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103923",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Antonio",
    lastName: "Piras",
    fisrtName: "Teresa",
    cell: "341 3210987",
    slug: "Tony",
    id: "29fk9306l",
    description: "Messaggio di Teresa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103924",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Carlo",
    lastName: "Valentini",
    fisrtName: "Anna",
    cell: "342 2109876",
    slug: "Carl",
    id: "30gk0417m",
    description: "Descrizione per Anna",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103925",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Franco",
    lastName: "Lombardi",
    fisrtName: "Clara",
    cell: "343 1098765",
    slug: "Frank",
    id: "31hk1528n",
    description: "Saluti da Clara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103926",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Paolo",
    lastName: "Sartori",
    fisrtName: "Giulia",
    cell: "344 9876543",
    slug: "Paul",
    id: "32ik2639o",
    description: "Descrizione per Giulia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103927",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Dario",
    lastName: "Colombo",
    fisrtName: "Margherita",
    cell: "345 8765432",
    slug: "Dar",
    id: "33jk3740p",
    description: "Saluti da Margherita",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103928",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Claudio",
    lastName: "Riva",
    fisrtName: "Alessia",
    cell: "346 7654321",
    slug: "Claud",
    id: "34kk4851q",
    description: "Messaggio di Alessia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103929",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Luigi",
    lastName: "Grassi",
    fisrtName: "Beatrice",
    cell: "347 6543210",
    slug: "Gigi",
    id: "35lk5962r",
    description: "Descrizione per Beatrice",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103930",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Roberto",
    lastName: "Guerra",
    fisrtName: "Ludovica",
    cell: "348 5432109",
    slug: "Rob",
    id: "36mk6073s",
    description: "Messaggio da Ludovica",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103931",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Michele",
    lastName: "Riccardi",
    fisrtName: "Ginevra",
    cell: "349 4321098",
    slug: "Mike",
    id: "37nk7184t",
    description: "Descrizione per Ginevra",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103932",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Stefano",
    lastName: "Farina",
    fisrtName: "Nicole",
    cell: "350 3210987",
    slug: "Steve",
    id: "38ok8295u",
    description: "Saluti da Nicole",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103933",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Davide",
    lastName: "Serra",
    fisrtName: "Carlotta",
    cell: "351 2109876",
    slug: "Dave",
    id: "39pk9306v",
    description: "Messaggio di Carlotta",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103934",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giacomo",
    lastName: "Bianco",
    fisrtName: "Flavia",
    cell: "352 1098765",
    slug: "Jack",
    id: "40qk0417w",
    description: "Descrizione per Flavia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103935",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giorgio",
    lastName: "Valli",
    fisrtName: "Luisa",
    cell: "353 9876543",
    slug: "George",
    id: "41rk1528x",
    description: "Saluti da Luisa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    bando: 'Nome bando',
    _id: "103936",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Maurizio",
    lastName: "Donati",
    fisrtName: "Marta",
    cell: "354 8765432",
    slug: "Maury",
    id: "42sk2639y",
    description: "Messaggio da Marta",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
];
